/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: fundebug
 * @Date: 2020/4/20
 * @Author: liux
 * @Copyright（C）2020 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import fundebug from 'bjxy-common/xyHelper/fundebug'

fundebug({
  apikey: 'c29b8cccba915c8c897b2b550b094553258b79e73c19bf2e55b7bf9a7c52d010',
  sampleRate: 0.3,
  filters: [
    {
      message: /Script\serror|^ReferenceError$|JSBridge|vivoNewsDetailPage|setWebViewFlag|TouTiao|onHidden|on_page_disappear|_setbackXML_|processRandomSelector|bridge|jsOnMessage|pajkOnMessage|x5onSkinSwitch|getElementById|getAndroidUnionSeries|MPing|property|BecomeActive|ResignActive|_plusready_dispatch|onAudioStateChanged|goToGetres|appWebGLStart|appWebGLStop|vivo|qbSniffJsVersion|WeixinJSBridge is not defined$|sogouMobileExplorer|vivoNewsDetailPage|x5onSkinSwitch is not defined$|sendData is not defined$|tad_get_back_gesture_enabled$|promise|restart is not defined$|mag is not defined$|tad_get_back_gesture_enabled$|x5onSkinSwitch is not defined$|\$\$/
    },
    {
      name: /unhandledrejection/g
    },
    {
      res: {
        elapsedTime: /\d{0}[3-9]\d{4,}/
      }
    },
    {
      target: {
        src: /revideo/
      }
    },

  ]
})
